exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b17714cc] .drawer{max-height:100vh;height:100vh;margin:0;transition:transform .5s}[data-v-b17714cc] .none-enter-to{transform:translateX(0)}[data-v-b17714cc] .none-enter-active,[data-v-b17714cc] .none-leave-active{transform:translateX(100%)}.v-dialog__content[data-v-b17714cc]{justify-content:flex-end;border-radius:0}", ""]);

// exports
